import { useTranslation } from 'react-i18next';

import { Flex, rem, Text } from '@bonusly/design-system';

import { ReactComponent as Animated } from '../../assets/images/loading-bubbles.svg';

export const Bubbles = () => {
	const { t } = useTranslation('monarch');

	return (
		<Flex alignItems="center" flexDir="column" pos="relative" w={rem(400)}>
			<Animated />
			<Text bottom={rem(40)} fontWeight="semibold" pos="absolute">
				{t('loading')}
			</Text>
		</Flex>
	);
};
